import Snackbar from '@/classes/snackbar';

export default {
  createSnackbarMessage: ({ commit }, payload) => commit('createSnackbarMessage', new Snackbar(payload)),
  removeSnackbarMessage: ({ commit }, payload) => commit('removeSnackbarMessage', payload),

  snackbarInfoMessage: ({ dispatch }, message) => {
    dispatch('createSnackbarMessage', { type: Snackbar.TYPE.INFO, message: { text: message } });
  },

  snackbarSuccessMessage: ({ dispatch }, message) => {
    dispatch('createSnackbarMessage', { type: Snackbar.TYPE.SUCCESS, message: { text: message } });
  },

  snackbarErrorMessage: ({ dispatch }, message) => {
    dispatch('createSnackbarMessage', { type: Snackbar.TYPE.ERROR, message: { text: message } });
  },

  snackbarWarningMessage: ({ dispatch }, message) => {
    dispatch('createSnackbarMessage', { type: Snackbar.TYPE.WARNING, message: { text: message } });
  }
};
